export default function reverse(array) { return [...array].reverse(); }
